import Close from "@mui/icons-material/Close";
import type { ReactNode } from "react";

import "./styles.css";
import { Box, IconButton, styled } from "@mui/material";
import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { useState } from "react";

import type { Mission } from "./type";

type MakerInnerProps = {
  width: number | "auto";
  height: number;
  $bgcolor?: string;
  $opacity?: number;
};

const MakerInner = styled(Box)<MakerInnerProps>(({ theme, $bgcolor, width, height, $opacity }) => ({
  backgroundColor: $bgcolor || theme.palette.primary.main,
  color: "white",
  opacity: $opacity ?? 1,
  borderRadius: "8px",
  padding: "5px 10px",
  position: "relative",
  width: typeof width === "number" ? `${width}px` : width,
  height: `${height}px`,
  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
  transitionProperty: "width, height",
  transitionDuration: "0.6s",
  "&::after": {
    content: '""',
    position: "absolute",
    left: "50%",
    top: "100%",
    transform: "translate(-50%, 0)",
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderTop: `8px solid ${$bgcolor || theme.palette.primary.main}`,
  },
}));
function MapMarker({
  title,
  description,
  mission: _mission,
  children,
  position,
  extraStyle,
  extendable = false,
}: {
  mission?: Mission;
  children?: React.ReactNode;
  title: ReactNode;
  description?: string;
  position: google.maps.LatLngLiteral;
  extraStyle?: {
    bgColor?: string;
    opacity?: number;
  };
  extendable?: boolean;
}) {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <AdvancedMarker position={position} onClick={() => extendable && setShowDetails(!showDetails)}>
      <MakerInner
        $bgcolor={extraStyle?.bgColor}
        $opacity={extraStyle?.opacity}
        width={showDetails ? 300 : extendable ? 150 : "auto"}
        height={showDetails ? 180 : extendable || description ? 50 : 30}
      >
        <div className="marker-main">
          <div style={{ width: 120, display: "block" }}>
            {title}
            {description ? (
              <span
                className="marker-description"
                style={{ whiteSpace: "normal", textTransform: "capitalize" }}
              >
                {description}
              </span>
            ) : null}
          </div>
        </div>
        {showDetails ? children : null}
        {showDetails ? (
          <IconButton
            aria-label="close"
            size="small"
            sx={{ position: "absolute", right: 0, top: 0, color: "whitesmoke" }}
          >
            <Close />
          </IconButton>
        ) : null}
      </MakerInner>
    </AdvancedMarker>
  );
}
export default MapMarker;
